/* LUMIERE Paris - theme behaviour */
(function () {
  'use strict';
  var R = window.lpRoutes || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart' };

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function money(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var value = parts.join('.');
    if (!format) return '$' + value;
    return format.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  /* ---------- mobile nav ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lp-burger]');
    if (!b) return;
    e.preventDefault();
    var nav = $('[data-lp-nav]');
    if (nav) nav.classList.toggle('is-open');
  });

  /* ---------- cart drawer ---------- */
  function openCart() { document.body.classList.add('lp-cart-open'); }
  function closeCart() { document.body.classList.remove('lp-cart-open'); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lp-cart-open]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-lp-cart-close]')) { e.preventDefault(); closeCart(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  function refreshDrawer(open) {
    return fetch(R.cart + '?section_id=lp-cart-drawer-section', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-lp-drawer-inner]');
        var live = $('[data-lp-drawer-inner]');
        if (fresh && live) live.innerHTML = fresh.innerHTML;
        var count = doc.querySelector('[data-lp-cart-count]');
        $$('[data-lp-cart-count]').forEach(function (n) { if (count) n.textContent = count.textContent; });
        if (open) openCart();
      })
      .catch(function () { if (open) window.location.href = R.cart; });
  }

  /* ---------- add to cart ---------- */
  function addToCart(items, btn) {
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    return fetch(R.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.d && res.d.description) || 'error');
        return refreshDrawer(true);
      })
      .catch(function () { window.location.href = R.cart; })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-lp-quick-add]');
    if (q) {
      e.preventDefault();
      addToCart([{ id: Number(q.getAttribute('data-lp-quick-add')), quantity: 1 }], q);
      return;
    }
    var line = e.target.closest('[data-lp-line-change]');
    if (line) {
      e.preventDefault();
      var key = line.getAttribute('data-lp-line-key');
      var qty = Number(line.getAttribute('data-lp-line-change'));
      fetch(R.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () {
        if (document.body.classList.contains('template-cart')) window.location.reload();
        else refreshDrawer(false);
      });
    }
  });

  /* ---------- product form ---------- */
  $$('[data-lp-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? Number(qtyInput.value) || 1 : 1;
      var tier = form.querySelector('[data-lp-tier].is-active');
      if (tier) qty = Number(tier.getAttribute('data-lp-tier-qty')) || qty;
      var items = [{ id: Number(idInput.value), quantity: qty }];
      if (tier && tier.getAttribute('data-lp-pair-id')) {
        items.push({ id: Number(tier.getAttribute('data-lp-pair-id')), quantity: 1 });
      }
      addToCart(items, form.querySelector('[data-lp-atc]'));
    });
  });

  /* quantity stepper */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-lp-step]');
    if (!s) return;
    e.preventDefault();
    var input = s.parentNode.querySelector('input');
    if (!input) return;
    var val = Number(input.value) || 1;
    val += Number(s.getAttribute('data-lp-step'));
    input.value = Math.max(1, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* bundle tiers */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-lp-tier]');
    if (!t) return;
    e.preventDefault();
    var wrap = t.closest('[data-lp-tiers]');
    $$('[data-lp-tier]', wrap).forEach(function (x) { x.classList.remove('is-active'); });
    t.classList.add('is-active');
    var form = t.closest('form');
    var qty = form && form.querySelector('[name="quantity"]');
    if (qty) qty.value = t.getAttribute('data-lp-tier-qty') || 1;
  });

  /* variant selection */
  $$('[data-lp-variants]').forEach(function (root) {
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-lp-variant-json]').textContent); } catch (err) { return; }
    var fmt = data.money_format;
    var selected = {};
    $$('[data-lp-opt]', root).forEach(function (btn) {
      var i = btn.getAttribute('data-lp-opt-index');
      if (btn.classList.contains('is-active')) selected[i] = btn.getAttribute('data-lp-opt-value');
    });

    function repriceTiers(unit) {
      $$('[data-lp-tier]', root).forEach(function (tier) {
        var q = Number(tier.getAttribute('data-lp-tier-qty')) || 1;
        var pct = Number(tier.getAttribute('data-lp-tier-percent')) || 100;
        var pairId = tier.getAttribute('data-lp-pair-id');
        var gross = pairId ? unit + (data.pair_price || 0) : unit * q;
        var total = pairId ? Math.round(gross * 0.9) : Math.round(gross * pct / 100);
        var saving = gross - total;
        var tEl = tier.querySelector('[data-lp-tier-total]') || tier.querySelector('.lp-tier__r b');
        var sEl = tier.querySelector('[data-lp-tier-save]') || tier.querySelector('.lp-tier__r small');
        if (tEl) tEl.textContent = money(total, fmt);
        if (sEl) sEl.innerHTML = saving > 0 ? 'Save ' + money(saving, fmt) : '&mdash;';
      });
    }

    function render() {
      var match = data.variants.filter(function (vr) {
        return Object.keys(selected).every(function (i) { return vr.options[Number(i)] === selected[i]; });
      })[0];
      if (!match) return;
      var idField = root.querySelector('[name="id"]');
      if (idField) idField.value = match.id;
      var price = root.querySelector('[data-lp-price]');
      if (price) price.innerHTML = match.price_html;
      var was = root.querySelector('[data-lp-was]');
      if (was) {
        was.style.display = match.compare_html ? '' : 'none';
        if (match.compare_html) was.innerHTML = match.compare_html;
      }
      var save = root.querySelector('[data-lp-save]');
      if (save) {
        save.style.display = match.save_label ? '' : 'none';
        save.textContent = match.save_label || '';
      }
      var atc = root.querySelector('[data-lp-atc]');
      if (atc) {
        atc.disabled = !match.available;
        atc.textContent = match.available ? atc.getAttribute('data-lp-label') : 'Sold out';
      }
      var stock = root.querySelector('[data-lp-stock]');
      if (stock) stock.textContent = match.available ? (match.inventory_line || '') : 'Currently unavailable.';
      var sel = root.querySelector('[data-lp-selected]');
      if (sel) sel.textContent = Object.keys(selected).map(function (k) { return selected[k]; }).join(' / ');
      repriceTiers(match.price);
      if (match.featured_index != null) selectImage(root, match.featured_index);
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-lp-opt]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = btn.getAttribute('data-lp-opt-index');
        selected[i] = btn.getAttribute('data-lp-opt-value');
        $$('[data-lp-opt][data-lp-opt-index="' + i + '"]', root).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        render();
      });
    });
    render();
  });

  /* gallery */
  function selectImage(root, index) {
    $$('[data-lp-main-img]', root).forEach(function (img) {
      img.classList.toggle('is-active', img.getAttribute('data-lp-main-img') === String(index));
    });
    $$('[data-lp-thumb]', root).forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-lp-thumb') === String(index));
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-lp-thumb]');
    if (!t) return;
    e.preventDefault();
    selectImage(t.closest('[data-lp-gallery]') || document, t.getAttribute('data-lp-thumb'));
  });

  /* accordions + faq */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lp-toggle]');
    if (!b) return;
    e.preventDefault();
    var panel = document.getElementById(b.getAttribute('aria-controls'));
    if (!panel) return;
    var open = panel.hasAttribute('hidden');
    if (open) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    var sign = b.querySelector('.s');
    if (sign) sign.textContent = open ? '\u2013' : '+';
  });

  /* hero slider */
  $$('[data-lp-slider]').forEach(function (slider) {
    var slides = $$('[data-lp-slide]', slider);
    var dots = $$('[data-lp-dot]', slider);
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var speed = Number(slider.getAttribute('data-lp-slider')) || 6000;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function restart() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, speed); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); restart(); }); });
    go(0); restart();
  });

  /* collection sort */
  $$('[data-lp-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* facet auto-submit */
  $$('[data-lp-facets]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });
})();
